import type { Volume } from '../types/product';

export const volumes: Volume[] = [
  {
    label: 'VOLUME I',
    title: 'Field Guide to Clearer, Client-Led Sessions',
    summary: 'A 50-page framework for the consultation, from opening to closure.',
    cover: 'https://cdn.magicpatterns.com/uploads/qSPNxMU7eckyhahniw9uZs/portada_vol_1.png',
    coverAlt: 'Cover of Volume I: Bach Flower Consultation Guide — Field Guide to Clearer, Client-Led Sessions',
    features: [
      'A clear sequence to open and structure the conversation',
      'Listening, clarification, and reflect-back prompts',
      'Boundaries, referral considerations, and session closure',
    ],
  },
  {
    label: 'VOLUME II',
    title: '15 Formula Studies',
    summary: '50 pages of educational studies based on traditional Bach Flower themes.',
    cover: 'https://cdn.magicpatterns.com/uploads/4QcWu7SDj66mhcU5oHSai3/portada_vol_2.png',
    coverAlt: 'Cover of Volume II: Bach Flower Formula Guide — 15 Formula Studies',
    features: [
      'Fifteen proposed educational blend studies',
      'The emotional themes and each flower’s role in the example',
      'Client-led reflection prompts and the limits of a study',
    ],
    note: 'Educational examples — not recipes, dosing, or individual recommendations.',
  },
  {
    label: 'VOLUME III',
    title: '50 Case Studies and a Practical Selection Map',
    summary: '50 pages of fictional teaching cases and structured reflection.',
    cover: 'https://cdn.magicpatterns.com/uploads/5PvqE2dfnavdmuCHELzPcH/Portada_vol_3.png',
    coverAlt: 'Cover of Volume III: Bach Flower Formula Guide — 50 Case Studies and a Practical Selection Map',
    features: [
      '40 developed cases + 10 shorter cases with a selection map',
      'Compare similar emotional descriptions side by side',
      'Reflection questions grounded in the client’s own words',
    ],
    note: 'The selection map organizes possibilities — it is not a diagnostic or treatment tool.',
  },
];
